import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ReportTypeId } from "../components/MainContent/pages/Reports/constants";

export interface ReportsState {
  activeReportId: ReportTypeId | null;
}

const initialState: ReportsState = {
  activeReportId: "case-status-all",
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setActiveReportId: (state, action: PayloadAction<ReportTypeId | null>) => {
      state.activeReportId = action.payload;
    },
  },
});

export const { setActiveReportId } = reportsSlice.actions;

export const selectActiveReportId = (state: { reports: ReportsState }) =>
  state.reports?.activeReportId ?? null;

export default reportsSlice.reducer;
